export default class numberUtils {
    static numberFormat(val) {
        val = '' + val // 转换成字符串
        let int = val
        int = int.split('').reverse().join('') // 翻转整数
        let temp = '' // 临时变量
        for (let i = 0; i < int.length; i++) {
            temp += int[i]
            if ((i + 1) % 3 === 0 && i !== int.length - 1) {
                temp += ',' // 每隔三个数字拼接一个逗号
            }
        }
        temp = temp.split('').reverse().join('') // 加完逗号之后翻转
        return temp
    }
}


// WEBPACK FOOTER //
// ./src/utils/numberUtils.js